module.exports = __webpack_public_path__ + "img/close.99d55bcb.png";